// JsFromRoutes CacheKey d16a73d30547c94cadfdcb0fe01ceb28
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  preview: /* #__PURE__ */ definePathHelper('get', '/preview/landing_page/:id'),
  show: /* #__PURE__ */ definePathHelper('get', '/gifts/:slug'),
  collectionLandingPage: /* #__PURE__ */ definePathHelper('get', '/collection/:slug'),
  index: /* #__PURE__ */ definePathHelper('get', '/'),
  root: /* #__PURE__ */ definePathHelper('get', '/'),
}
